import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { NORWEGIAN_REGIONS } from '../lib/regions';

const DATALIST_ID = 'region-options-shared';

export const CustomerFormFields = ({ data, onChange, showCleaningInterval = false }) => {
  const set = (field) => (e) => onChange(field, e.target.value);
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="cff_name">Firmanavn *</Label>
        <Input id="cff_name" data-testid="customer-name-input" value={data.name} onChange={set('name')} required className="input-field" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="cff_contact">Kontaktperson *</Label>
        <Input id="cff_contact" data-testid="contact-person-input" value={data.contact_person} onChange={set('contact_person')} required className="input-field" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="cff_phone">Telefon *</Label>
        <Input id="cff_phone" data-testid="phone-input" value={data.phone} onChange={set('phone')} required className="input-field" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="cff_email">E-post</Label>
        <Input id="cff_email" data-testid="email-input" type="email" value={data.email} onChange={set('email')} className="input-field" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="cff_address">Adresse *</Label>
        <Input id="cff_address" data-testid="address-input" value={data.address} onChange={set('address')} required className="input-field" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="cff_postal">Postnummer</Label>
        <Input id="cff_postal" data-testid="postal-code-input" value={data.postal_code} onChange={set('postal_code')} className="input-field" placeholder="0000" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="cff_region">Område</Label>
        <Input id="cff_region" data-testid="region-input" list={DATALIST_ID} value={data.region} onChange={set('region')} className="input-field" placeholder="F.eks. Oslo, Innlandet" />
        <datalist id={DATALIST_ID}>
          {NORWEGIAN_REGIONS.map((r) => <option key={r} value={r} />)}
        </datalist>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <div className="space-y-2">
          <Label htmlFor="cff_door">Dørkode</Label>
          <Input id="cff_door" data-testid="door-code-input" value={data.door_code} onChange={set('door_code')} className="input-field" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="cff_gate">Portkode</Label>
          <Input id="cff_gate" data-testid="gate-code-input" value={data.gate_code} onChange={set('gate_code')} className="input-field" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="cff_alarm">Alarmkode</Label>
          <Input id="cff_alarm" data-testid="alarm-code-input" value={data.alarm_code} onChange={set('alarm_code')} className="input-field" />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="cff_access">Tilgangsinfo / nøkkelinfo</Label>
        <Textarea id="cff_access" data-testid="access-info-input" value={data.access_info} onChange={set('access_info')} rows={2} className="input-field" placeholder="F.eks. nøkkelboks-plassering" />
      </div>
      {showCleaningInterval && (
        <div className="space-y-2">
          <Label htmlFor="cff_interval">Rensesyklus (uker)</Label>
          <Select value={data.cleaning_interval} onValueChange={(v) => onChange('cleaning_interval', v)}>
            <SelectTrigger className="input-field" data-testid="cleaning-interval-select">
              <SelectValue placeholder="Velg intervall" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="0">Ingen rensesyklus</SelectItem>
              <SelectItem value="2">Hver 2. uke</SelectItem>
              <SelectItem value="3">Hver 3. uke</SelectItem>
              <SelectItem value="4">Hver 4. uke</SelectItem>
              <SelectItem value="6">Hver 6. uke</SelectItem>
              <SelectItem value="8">Hver 8. uke</SelectItem>
              <SelectItem value="12">Hver 12. uke</SelectItem>
            </SelectContent>
          </Select>
        </div>
      )}
    </>
  );
};

export default CustomerFormFields;
